import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../../crystal-elements/cc-base.component';
import {CommonFieldService} from '../../../services/common/common-field.service';
import {CookieNames} from '../../../shared/cookie/cookie-names';
import {AppConfigService} from "../../../services/app-config.service";
import {EticketService} from "../../../services/eticket/eticket.service";
import {CcStorageService} from "../../../services/common/cc-storage.service";
import {EMPTY, exhaustMap, takeUntil, timer} from "rxjs";
import {catchError} from "rxjs/operators";

@Component({
  selector: 'app-eticket-views',
  templateUrl: './e-ticket-views.component.html',
  styleUrls: ['./e-ticket-views.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ETicketViewsComponent extends CcBaseComponent {

  desks: string[] = [];
  selectedViewIndex: number = -1;
  initialised: boolean = false;

  selectedDesk: string;

  transPartKey: string = 'eticket.list-eticket';

  autoReloadTimeOut: number = 2000;

  private refreshViewsSub?: any;

  constructor(cdref: ChangeDetectorRef,
              private storageService: CcStorageService,
              private commonFieldService: CommonFieldService,
              private eticketService: EticketService,
              private appConfigService: AppConfigService,
              protected componentFactoryResolver: ComponentFactoryResolver,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              protected translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    setTimeout(() => {
      this.startRefreshViewsLoop();
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }


  protected initConfigs() {
    super.initConfigs();
  }

  protected initData() {
    super.initData();
  }

  viewChanged(index: number) {
    if (this.desks.length > index) {
      this.storageService.set(CookieNames.ETICKET_VIEW_SELECTED, this.desks[index]);
      this.selectedDesk = this.desks[index];
    }
  }

  startRefreshViewsLoop(): void {
    // stop any existing loop
    this.refreshViewsSub?.unsubscribe();

    // if disabled, do a one-shot fetch and exit
    if (!this.autoReloadTimeOut || this.autoReloadTimeOut <= 0) {
      this.refreshViewsOnce();
      return;
    }

    this.refreshViewsSub = timer(0, this.autoReloadTimeOut)
      .pipe(
        takeUntil(this.destroy$),

        // one HTTP call at a time
        exhaustMap(() =>
          this.eticketService.getDesks().pipe(
            catchError(err => {
              // keep loop alive, but don't crash
              this.desks = ['-'];
              this.markForCheck();
              return EMPTY;
            }),
          ),
        ),
      )
      .subscribe(apiValidation => this.applyDesksResult(apiValidation));
  }

  refreshViewsOnce(): void {
    this.eticketService.getDesks()
      .pipe(takeUntil(this.destroy$))
      .subscribe(apiValidation => this.applyDesksResult(apiValidation));
  }

  private applyDesksResult(apiValidation: any): void {
    if (!apiValidation.success) {
      this.desks = ['-'];
      this.markForCheck();
      return;
    }

    // If identical list, do nothing (the loop will handle next tick)
    if (
      this.desks.length > 0 &&
      this.desks.length === apiValidation.item.length &&
      this.desks.every((desk, i) => desk === apiValidation.item[i])
    ) {
      return;
    }

    this.desks.splice(0);
    this.desks.push(...apiValidation.item);
    this.desks = [...this.desks];

    if (this.desks.length === 0) {
      this.desks = ['-'];
    }

    if (this.desks.length > 0) {
      let currentViewName: string | undefined;

      if (this.storageService.check(CookieNames.ETICKET_VIEW_SELECTED)) {
        currentViewName = this.storageService.get(CookieNames.ETICKET_VIEW_SELECTED);
      }
      if (!currentViewName) {
        currentViewName = this.desks[0];
      }

      let currentUserViewIndex = this.desks.findIndex(v => v === currentViewName);
      if (currentUserViewIndex < 0) {
        currentViewName = this.desks[0];
        currentUserViewIndex = 0;
      }

      this.selectedDesk = this.desks[currentUserViewIndex];

      if (!this.initialised || this.selectedViewIndex !== currentUserViewIndex) {
        this.initialised = true;

        if (this.selectedViewIndex === currentUserViewIndex) {
          setTimeout(() => {
            this.selectedDesk = undefined;
            this.selectedViewIndex = -1;
            this.markForCheck();
          });
        }

        this.selectedViewIndex = currentUserViewIndex;
      }
    }

    setTimeout(() => this.markForCheck());
    this.markForCheck();
  }

  trackByDesk(index: number, desk: string): string {
    return desk;
  }

}


